"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerBoard = void 0;
class AnswerBoard {
    constructor(id) {
        this.answerBoard = document.createElement('div');
        this.answerBoard.id = id;
        this.answerBoard.className = id;
    }
    render() {
        const newStringOutput = document.createElement('div');
        newStringOutput.id = 'current-output';
        newStringOutput.className = 'output';
        this.answerBoard.append(newStringOutput);
        return this.answerBoard;
    }
}
exports.AnswerBoard = AnswerBoard;
